"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var use_theme_1 = __importDefault(require("../hooks/use-theme"));
var tailwind_1 = __importDefault(require("../utils/tailwind"));
var styles = (0, tailwind_1.default)({
  // see styles.css
  svg: "\n    react-celo-spinner",
  circle: "\n    react-celo-spinner-path\n    tw-stroke-current"
});
function Spinner(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  var theme = (0, use_theme_1.default)();
  return react_1.default.createElement("svg", {
    className: "".concat(styles.svg, " ").concat(className),
    style: Object.assign({
      color: theme.primary
    }, style),
    viewBox: "0 0 50 50"
  }, react_1.default.createElement("circle", {
    className: styles.circle,
    cx: 25,
    cy: 25,
    r: 20,
    strokeWidth: "5",
    fill: "none"
  }));
}
exports.default = Spinner;